import React from "react";
import { Dispatcher, Constants } from "../../../flux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from '@fortawesome/free-solid-svg-icons';

class NavbarToggle extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    Dispatcher.dispatch({
      actionType: Constants.TOGGLE_SIDEBAR
    });
  }

  render() {
    return (
      <nav className="nav">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          className="nav-link nav-link-icon toggle-sidebar d-sm-inline d-md-inline d-lg-none text-center"
          onClick={this.handleClick}
          style={{
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            color: '#495057',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderLeft: '1px solid #eaedf3',
            height: '100%'
          }}
        >
          <FontAwesomeIcon 
            icon={faBars} 
            style={{ 
              fontSize: '1.1rem'
            }} 
          />
        </a>
      </nav>
    );
  }
}

export default NavbarToggle;
